import NewActivity from "./NewActivity";
import ActivityItem from "./ActivityItem";
import "./Activity.css";

import { deleteActivity, create, update } from "../../store/api/WorkItemActivitiesApi";
import { getUserListASync } from "../../../store/api/Users";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

export default function ActivityList({
    workItemId,
    activities,
    control,
    onChange
}) {

    const dispatch = useDispatch();
    const setList = (updater) => {
        const newList = updater(activities) || [];
        onChange?.(newList);
    };

    // ======================
    // CREATE
    // ======================
    const handleCreate = async (model) => {
        const result = await create(model);

        if (result?.Error) {
            setErrorDialog(dispatch, result.Error, "ثبت یادداشت", 10000);
            return result; // error
        }
        if (result.Data) {
            setList(prev => [...prev, result.Data]);
        }

        return result;
    };

    // ======================
    // UPDATE
    // ======================
    const handleUpdate = async (model) => {

        const result = await update(model);

        if (result?.Error) {
            setErrorDialog(dispatch, result.Error, "ویرایش یادداشت", 1000);
            return result; // error
        }
        if (result.Data) {
            setList(prev =>
                prev.map(c =>
                    c.ID === model.ID ? { ...model } : c
                )
            );
        }

        return result;
    };

    // ======================
    // DELETE
    // ======================
    const handleDelete = async (id) => {

        const result = await deleteActivity(id);

        if (result?.Error) {
            setErrorDialog(dispatch, result.Error, "حذف یادداشت", 1000);
            return result; // error
        }

        setList(prev =>
            prev.filter(c => c.ID !== id)
        );

        return result;
    };
    const loadUserOptions = async (qry) => {
        const result = await getUserListASync(qry);
        if (Array.isArray(result)) {
            return result.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }

    return (
        <div className="workitem-activity-list mt-2 scThin">
            <NewActivity workItemId={workItemId} onCreate={handleCreate} control={control} loadUserOptions={loadUserOptions} />

            {activities.length === 0 && (
                <div className="text-muted text-center py-3">
                    هنوز فعالیتی ثبت نشده است
                </div>
            )}

            {activities.map(act => (
                <ActivityItem
                    control={control}
                    key={act.ID}
                    activity={act}
                    onUpdate={handleUpdate}
                    onDelete={handleDelete}
                    loadUserOptions={loadUserOptions}
                />
            ))}

        </div>
    );
}